var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useFormContext } from 'react-hook-form';
import { useCallback, useEffect, useRef, useState } from 'react';
import { convertToISODuration } from '../../../utils/durationUtils';
export function useBuffers(_a) {
    var spaceBuffers = _a.spaceBuffers, spaceId = _a.spaceId, onTrackBufferEvent = _a.onTrackBufferEvent;
    var _b = useFormContext(), setValue = _b.setValue, getValues = _b.getValues;
    var _c = __read(useState(function () {
        // Initialize showBuffers based on current form state
        return !!(spaceBuffers === null || spaceBuffers === void 0 ? void 0 : spaceBuffers[spaceId]);
    }), 2), showBuffers = _c[0], setShowBuffers = _c[1];
    var debounceRef = useRef(null);
    var handleUpdateBuffers = useCallback(function (value, bufferType, timeType) {
        var _a;
        if (!spaceBuffers)
            return;
        var bufferValue = convertToISODuration(value.toString(), timeType);
        var updatedSpaceBuffers = __assign(__assign({}, spaceBuffers[spaceId]), (_a = {}, _a[bufferType] = !value ? undefined : bufferValue, _a));
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(function () {
            var _a;
            setValue('spaceBuffers', __assign(__assign({}, spaceBuffers), (_a = {}, _a[spaceId] = updatedSpaceBuffers, _a)));
        }, 300);
    }, [spaceBuffers, setValue, spaceId]);
    var onRemoveBuffer = useCallback(function () {
        var currentSpaceBuffers = getValues('spaceBuffers');
        if (!currentSpaceBuffers)
            return;
        var updatedSpaceBuffers = __assign({}, currentSpaceBuffers);
        delete updatedSpaceBuffers[spaceId];
        setShowBuffers(false);
        debounceRef.current = setTimeout(function () {
            if (Object.keys(updatedSpaceBuffers).length === 0) {
                setValue('spaceBuffers', undefined, { shouldDirty: true });
            }
            else {
                setValue('spaceBuffers', updatedSpaceBuffers, { shouldDirty: true });
            }
        }, 300);
    }, [getValues, setValue, spaceId]);
    var onAddBuffer = useCallback(function () {
        var _a;
        var _b, _c;
        var currentSpaceBuffers = getValues('spaceBuffers');
        if (currentSpaceBuffers === null || currentSpaceBuffers === void 0 ? void 0 : currentSpaceBuffers[spaceId]) {
            return;
        }
        setShowBuffers(true);
        setValue('spaceBuffers', __assign(__assign({}, currentSpaceBuffers), (_a = {}, _a[spaceId] = {
            beforeEvent: convertToISODuration('15', 'minutes'),
            bufferBeforeId: (_b = currentSpaceBuffers === null || currentSpaceBuffers === void 0 ? void 0 : currentSpaceBuffers[spaceId]) === null || _b === void 0 ? void 0 : _b.bufferBeforeId,
            afterEvent: convertToISODuration('15', 'minutes'),
            bufferAfterId: (_c = currentSpaceBuffers === null || currentSpaceBuffers === void 0 ? void 0 : currentSpaceBuffers[spaceId]) === null || _c === void 0 ? void 0 : _c.bufferAfterId,
        }, _a)));
    }, [getValues, setValue, spaceId]);
    useEffect(function () {
        return function () {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
        };
    }, []);
    return {
        handleUpdateBuffers: handleUpdateBuffers,
        onRemoveBuffer: onRemoveBuffer,
        onAddBuffer: onAddBuffer,
        showBuffers: showBuffers,
    };
}
